import React from 'react';
import { styles } from './HeroTile.css';
import { CardProps } from '../Card';

export type HeroTileProps = Pick<CardProps, 'cover' | 'heading' | 'content' | 'onClick' | 'href' | 'target'>;

export const HeroTile = ({ cover, heading, content, onClick, href, target }: HeroTileProps) => {
  return (
    <a className={styles.container} onClick={onClick} href={href} target={target}>
      {cover ? cover : null}
      <div className={styles.body}>
        {heading ? <h2 className={styles.heading}>{heading}</h2> : null}
        {content ? <p className={styles.content}>{content}</p> : null}
      </div>
    </a>
  );
};
